<div class="chapter-questions-container">
    <app-exam-header></app-exam-header>
    <div class="content-wrapper">
        <section class="section-xl">
            <div class="container-fluid">
                <div class="row mb-4">
                    <div class="col-md-12">
                        <button class="back-btn" (click)="goBackToDashboard()">
                            <i class="fas fa-arrow-left"></i> Back to Dashboard
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="pbmit-heading-subheading text-center">
                            <!-- <div class="assessment-badge">CHAPTER ASSESSMENT</div> -->
                            <h2 class="pbmit-title">{{chapterDetails?.name}}</h2>
                            <div class="divider">
                                <span></span>
                            </div>
                            <div class="pbmit-heading-desc pt-3">
                                Please answer all questions thoroughly. Your responses will help assess your understanding of the chapter content.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1"></div>
                    <div class="col-md-10">
                        <div class="accordion" id="accordionExample2">
                            <div class="accordion-item" [ngClass]="currentQuestion == i?'active':''" *ngFor="let que of chapterQuestions;let i = index;">
                                <h2 class="accordion-header" id="heading{{i}}">
                                    <button class="accordion-button" [ngClass]="currentQuestion == i?'':'collapsed'" (click)="currentQuestion = i;" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" [attr.aria-controls]="'collapse'+i">
                                        <span>{{i+1}}.</span> <span class="queName" [innerHTML]="que.name"></span>
                                    </button>
                                </h2>
                                <div [id]="'collapse'+i" class="accordion-collapse collapse" [ngClass]="currentQuestion == i?'show':''" [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <textarea placeholder="Type your answer here..." name="que.answer" [(ngModel)]="que.answer"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="actions-container">
                            <div class="question-navigation" *ngIf="chapterQuestions && chapterQuestions.length > 0">
                                <button class="nav-btn" [disabled]="currentQuestion === 0" (click)="navigateToPrevious()">Previous</button>
                                <button class="nav-btn" [disabled]="currentQuestion === chapterQuestions.length - 1" (click)="navigateToNext()">Next</button>
                            </div>
                            <div class="actions-buttons">
                                <button class="draft-btn" (click)="saveDraft(chapterQuestions[currentQuestion])">Save as draft</button>
                                <button class="pbmit-btn" (click)="saveAnswers()">Submit answers</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1"></div>
                </div>
            </div>
        </section>
    </div>
    <app-exam-footer></app-exam-footer>
</div>

